import quoteListHndb from '../templates/quote-list.handlebars';
import quoteListItemsHndb from '../templates/quote-items.handlebars';

import Activity from './activity';
import Quote from './quote';
import Notification from '../../shared/notification';
import { Modal } from '../../shared/modal';
import { getRedirectUrl } from '../../shared/shared';
import { LocalQuote } from '../local-quote';
import { View } from './view';
import { addScrollOverlays } from '../lib/scrollable-overlay';
import { handleLoadCartClick } from '../menu-handlers/load-cart-click';
import { prepareNewCart } from '../menu-handlers/new-cart-click';

export default class QuoteList extends View {
    constructor(view, data, app) {
        super(view);
        this.app = app;
        this.data = data;
    }

    filters = {
        state: 'none',
        win: 'none',
        order: 'DESC',
    };

    quoteListEl = document.createElement('div');

    #getQuoteParams() {
        let quotesParams = {
            search: this.quoteListEl.querySelector('#quote-list-search').value,
        };

        if (this.filters.win !== 'none') {
            quotesParams.win = this.filters.win;
        }
        if (this.filters.state !== 'none') {
            quotesParams.state = this.filters.state;
        }

        quotesParams.order = this.filters.order;

        return quotesParams;
    }

    async #updateSummary(params) {
        const summaryEl = this.quoteListEl.querySelector('#quote-list-summary');
        let quotes;
        if (params) {
            const notification = new Notification({ type: 'loading' });
            notification.open();
            
            const sellerId = this.app.session.sellerDetails.id;
            const { data, status, message } = await this.app.service.getQuotes(
                sellerId,
                params
            );

            if (!data) {
                notification.reload({
                    type: 'error',
                    message
                });
            } else {
                quotes = data.quotes;
                notification.close();
            }
        } else {
            quotes = this.data.quotes;
        }

        summaryEl.innerHTML = quoteListItemsHndb({ ...this.data, quotes });
        addScrollOverlays(summaryEl, false, true);
    }

    #listeners() {
        let qlsTimeoutId;
        this.filters = {
            state: this.quoteListEl.querySelector('#quote-list-state').value,
            win: this.quoteListEl.querySelector('#quote-list-win').value,
            order: this.quoteListEl.querySelector('#quote-list-order').value,
        };

        this.quoteListEl
            .querySelector('.os-quote-list__top-bar')
            .addEventListener('click', async(e) => {
                e.preventDefault();

                if (e.target.id === 'quote-list-create') {
                    handleLoadCartClick(e, this.app);
                } else if (e.target.id === 'quote-list-new') {
                    await prepareNewCart(this.app.service, this.app.session);
                    return (window.location.href = '/');
                }
            });

        this.quoteListEl
            .querySelector('.os-quote-list__bottom-actions')
            .addEventListener('click', async(e) => {
                e.preventDefault();

                if (e.target.id === 'quote-list-quote' || e.target.closest('#quote-list-quote')) {
                    const button = e.target.closest('#quote-list-quote') || e.target;
                    
                    // Check if button is disabled
                    if (button.classList.contains('disabled')) {
                        return;
                    }
                    const modal = new Modal({
                        containerId: 'quote-modal',
                        padding: 0,
                        maxWidth: '1100px',
                    });

                    const notification = new Notification({ type: 'loading' });

                    notification.open();

                    const cartId = (await this.app.service.getCartDetails())?.id ?? LocalQuote.WILDCARD;

                    let data = await LocalQuote.get(cartId),
                        status,
                        message;

                    const tcc = this.app.session.tcc;
                    if (!data) {
                        ({
                            data,
                            status,
                            message,
                        } = await this.app.service.getQuoteByCartId(cartId, tcc));
                    }

                    if (!data.quote) {
                        return notification.reload({
                            type: 'error',
                            message
                        });
                    }
                    
                    data.wildcard = cartId === LocalQuote.WILDCARD;
                    data.share_by = this.app.session.sessionDetails.shareMediums;
                    data.templates = this.app.session.sessionDetails.templates;
                    data.suggestedMessage = this.app.session.sessionDetails.suggestedMessage;
                    const quoteModal = new Quote(modal, data, this.app);
                    quoteModal.load();
                    modal.open();
                    notification.close();
                }
            });

        this.quoteListEl
            .querySelector('#quote-list-search')
            .addEventListener('input', (e) => {
                clearTimeout(qlsTimeoutId);

                qlsTimeoutId = setTimeout(async () => {
                    if (
                        e.target.value.length == 0 ||
                        e.target.value.length > 3
                    ) {
                        const params = this.#getQuoteParams();
                        this.#updateSummary(params);
                    }
                }, 1000);
            });

        this.quoteListEl.addEventListener('change', async (e) => {
            if (
                e.target.name === 'state' ||
                e.target.name === 'win' ||
                e.target.name === 'order'
            ) {
                this.filters[e.target.name] = e.target.value;

                const params = this.#getQuoteParams();
                this.#updateSummary(params);
            }
        });

        this.quoteListEl
            .querySelector('#quote-list-summary')
            .addEventListener('click', async (e) => {
                const quoteClickEl = e.target.closest('[data-quote-id]');
                const quoteClicked = this.data.quotes.find((q) => q.id == quoteClickEl.dataset.quoteId);

                if (e.target.id === 'os-view-quote') {
                    const modal = new Modal({
                        containerId: `quote-modal-${quoteClicked.id}`,
                        padding: 0,
                        maxWidth: '1100px',
                    });

                    const notification = new Notification({
                        type: 'loading',
                    });

                    notification.open();

                    const { data, status, message } = await this.app.service.getQuote(quoteClicked.id);

                    if (!data.quote) {
                        return notification.reload({
                            type: 'error',
                            message: message,
                        });
                    }

                    data.templates = this.app.session.sessionDetails.templates;
                    data.share_by = this.app.session.sessionDetails.shareMediums;
                    data.read_only = true;

                    const quoteModal = new Quote(modal, data, this.app);
                    quoteModal.load();
                    modal.open();
                    notification.close();   
                }

                if (e.target.id === 'os-load-quote') {
                    const notification = new Notification({ type: 'loading' });

                    notification.open();

                    const { data: redirect, status } = await this.app.service.loadQuote(quoteClicked.id);

                    if (status == 0) {
                        this.app.session.sessionDetails = {
                            currentCartId: '',
                            currentQuoteState: '',
                            currentQuoteId: quoteClicked.id,
                            currentQuoteNumber: quoteClicked.number,
                            tcc: quoteClicked.tcc,
                        };
                        LocalQuote.remove(quoteClicked.seller_cart_id);
                        window.location.href = getRedirectUrl(
                            redirect.cart_url
                        );
                    }
                }

                if (e.target.id === 'os-open-activity' || e.target.id === 'os-open-activity-fast') {
                    const notification = new Notification({ type: 'loading' });
                    const isFast = e.target.id === 'os-open-activity-fast';

                    notification.open();
                    const { data, status, message } =
                        await this.app.service.getActivities(quoteClicked.id, isFast && {exclude: 'activities'});

                    if (status == 0) {
                        e.target.querySelector('#unread-activity-indicator')?.remove();
                        const activity = new Activity(
                            new Modal({
                                containerId: `activity-modal-${quoteClicked.id}`,
                                maxWidth: '700px',
                                height: isFast ? 'fit-content' : '95%',
                                borderRadius: '0px',
                                padding: '0px',
                            }),
                            {
                                ...data,
                                isFast,
                                prospect: quoteClicked.prospect,
                                win: quoteClicked.win,
                                quote_number: quoteClicked.number,
                                quote_id: quoteClicked.id,
                                selected_impact: this.app.session.sessionDetails?.activity?.minimum_impact || 3
                            },
                            this.app
                        );
                        notification.close();
                        activity.open();
                    } else {
                        notification.reload({
                            type: 'error',
                            message,
                        });
                    }
                }
            });
    }

    async open() {
        // Get current cart and quote information
        const cartDetails = await this.app.service.getCartDetails();
        const sessionDetails = this.app.session.sessionDetails;
        
        const templateData = {
            ...this.data,
            currentCartId: cartDetails?.id,
            currentQuoteNumber: sessionDetails?.currentQuoteNumber
        };
        
        this.quoteListEl.innerHTML = quoteListHndb(templateData);
        this.view.update(this.quoteListEl);
        this.view.open();
        this.#listeners();
        addScrollOverlays(this.quoteListEl.querySelector('#quote-list-summary'), false, true);
    }
}
